module.exports = __webpack_public_path__ + "img/fyq.fef08d98.jpg";